import loadable from '@loadable/component';
import { fetchCategoryList } from '../../actions/category';
import Loading from '../../components/Loader';

const Find = loadable(() => import(/* webpackChunkName: "howItWorks" */ './index'), {
  fallback: Loading
});

Find.needs = async (props, { dispatch }) => {
  const popularCategory = dispatch(fetchCategoryList('/categories/seo'));
  const allCategory = dispatch(fetchCategoryList('/categories/nonseo'));

  return Promise.all([popularCategory, allCategory]);
};

export default Find;
